import { render } from "./PhotoList.vue?vue&type=template&id=46f9c21a"
import script from "./PhotoList.vue?vue&type=script&lang=js"
export * from "./PhotoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__